// extracted by mini-css-extract-plugin
export default {"aboutContainer":"AboutPage_aboutContainer__D2ffU","aboutBody":"AboutPage_aboutBody__HZz-9"};